<template>
  <b-col align-self="center" class="white-box selects">
    <div class="d-flex w-100">
      <slot name="image"></slot>
      <slot name="options"></slot>
    </div>
  </b-col>
</template>

<script>
export default {
}
</script>

<style>
</style>
